import React, { useState } from 'react';
import { Table, Button, Modal, Form, Input, InputNumber, Select, Tag, Checkbox } from 'antd';

const { Option } = Select;

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

const TenantForm = ({ visible, onCancel, onCreate }: any) => {
  const [form] = Form.useForm();
  return (
    <Modal
      visible={visible}
      title="Create a new tenant"
      okText="Create"
      cancelText="Cancel"
      onCancel={onCancel}
      onOk={() => {
        form
          .validateFields()
          .then(values => {
            form.resetFields();
            onCreate(values);
          })
          .catch(info => {
            console.log('Validate Failed:', info);
          });
      }}
    >
      <Form form={form} {...layout} name="tenant_form">
        <Form.Item name="name" label="Tenant Name" rules={[{ required: true, message: 'Please input the tenant name!' }]}>
          <Input />
        </Form.Item>
        <Form.Item name="adminEmail" label="Admin Email" rules={[{ required: true, type: 'email', message: 'Please input a valid email!' }]}>
          <Input />
        </Form.Item>
        <Form.Item name="maxInstances" label="Max Concurrent Instances" initialValue={10}>
          <InputNumber min={1} />
        </Form.Item>
        <Form.Item name="maxTasksPerDay" label="Max Tasks Per Day" initialValue={100}>
          <InputNumber min={1} />
        </Form.Item>
        <Form.Item name="dataRetention" label="Data Retention (days)" initialValue={30}>
          <InputNumber min={1} />
        </Form.Item>
        <Form.Item name="allowedImages" label="Allowed Images" initialValue={['android-12', 'android-13']}>
          <Select mode="tags" placeholder="Select allowed images" />
        </Form.Item>
        <Form.Item name="featureTier" label="Feature Tier" initialValue="standard">
            <Select>
                <Option value="free">Free</Option>
                <Option value="standard">Standard</Option>
                <Option value="premium">Premium</Option>
            </Select>
        </Form.Item>
        <Form.Item name="enabledFeatures" label="Enabled Features">
            <Checkbox.Group>
                <Checkbox value="dynamic-deshell">Dynamic De-shelling</Checkbox>
                <Checkbox value="function-graph">Function Call Graphing</Checkbox>
                <Checkbox value="perf-monitoring">Performance Monitoring</Checkbox>
            </Checkbox.Group>
        </Form.Item>
      </Form>
    </Modal>
  );
};

const TenantPage = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [tenants, setTenants] = useState([
    {
      key: '1',
      name: 'Customer Alpha',
      admin: 'admin@alpha.com',
      status: 'Active',
      maxInstances: 20,
      maxTasksPerDay: 200,
      dataRetention: 90,
      allowedImages: ['android-12', 'android-13', 'beta'],
      featureTier: 'Premium',
    },
    {
      key: '2',
      name: 'Customer Beta',
      admin: 'admin@beta.com',
      status: 'Active',
      maxInstances: 5,
      maxTasksPerDay: 50,
      dataRetention: 30,
      allowedImages: ['android-12'],
      featureTier: 'Standard',
    },
    {
      key: '3',
      name: 'Customer Gamma (Disabled)',
      admin: 'admin@gamma.com',
      status: 'Disabled',
      maxInstances: 10,
      maxTasksPerDay: 100,
      dataRetention: 60,
      allowedImages: ['android-12', 'android-13'],
      featureTier: 'Free',
    },
  ]);

  const onCreate = (values: any) => {
    console.log('Received values of form: ', values);
    const newTenant = {
        key: (tenants.length + 1).toString(),
        name: values.name,
        admin: values.adminEmail,
        status: 'Active',
        featureTier: values.featureTier.charAt(0).toUpperCase() + values.featureTier.slice(1),
        ...values
    };
    setTenants([...tenants, newTenant]);
    setIsModalVisible(false);
  };

  const columns = [
    { title: 'Tenant Name', dataIndex: 'name', key: 'name' },
    { title: 'Admin Contact', dataIndex: 'admin', key: 'admin' },
    { title: 'Status', dataIndex: 'status', key: 'status', render: (status:string) => <Tag color={status === 'Active' ? 'green' : 'red'}>{status}</Tag> },
    { title: 'Feature Tier', dataIndex: 'featureTier', key: 'featureTier', render: (tier:string) => {
        let color = 'default';
        if (tier === 'Premium') color = 'gold';
        if (tier === 'Standard') color = 'blue';
        return <Tag color={color}>{tier}</Tag>;
    }},
    { title: 'Max Instances', dataIndex: 'maxInstances', key: 'maxInstances' },
    { title: 'Max Tasks/Day', dataIndex: 'maxTasksPerDay', key: 'maxTasksPerDay' },
    { title: 'Data Retention (Days)', dataIndex: 'dataRetention', key: 'dataRetention' },
    { title: 'Actions', key: 'actions', render: () => <a>Edit</a> },
  ];

  return (
    <div>
      <Button type="primary" onClick={() => setIsModalVisible(true)} style={{ marginBottom: 16 }}>
        Create Tenant
      </Button>
      <TenantForm
        visible={isModalVisible}
        onCreate={onCreate}
        onCancel={() => setIsModalVisible(false)}
      />
      <Table columns={columns} dataSource={tenants} />
    </div>
  );
};

export default TenantPage;
